import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ibanMask',
  standalone: true,
})
export class IbanMaskPipe implements PipeTransform {
  transform(
    value: string | undefined,
    visibleDigits = 4,
    maskChar = '*'
  ): string {
    if (!value) return '';
    const masked = value.slice(-visibleDigits);
    return `${maskChar.repeat(4)}${masked}`;
  }
}
